/**
 * Finds the nearest common ancestor for a collection of DOM nodes
 * @param nodes - Collection of DOM nodes
 * @returns The nearest common ancestor or null if not found
 */
export default function findNearestCommonParent(nodes: NodeListOf<Element> | HTMLCollectionOf<Element> | Element[]): Element | null {
  if (!nodes || nodes.length === 0) {
    return null;
  }

  if (nodes.length === 1) {
    return nodes[0].parentElement;
  }

  const nodesArray: Element[] = Array.from(nodes);

  // Start with the parent of the first element
  let commonAncestor: Element | null = nodesArray[0].parentElement;

  // Check if this parent contains all other nodes
  while (commonAncestor) {
    let containsAll = true;

    for (let i = 1; i < nodesArray.length; i++) {
      // Use contains() to check if the parent contains the current node
      if (!commonAncestor.contains(nodesArray[i])) {
        containsAll = false;
        break;
      }
    }

    if (containsAll) {
      return commonAncestor;
    }

    commonAncestor = commonAncestor.parentElement;
  }

  return document.documentElement;
}
